<template>
  <div class="classType flexItem">
    <h4>课程分类</h4>
    <div
      v-for="(classInfo, index) of this.classify"
      class="classTypeItem"
      :key="index"
    >
      <h6>{{ classInfo.title }}</h6>
      <router-link
        v-for="(child, childIndex) of classInfo.list"
        :key="childIndex"
        class="classTypeLink"
        :to="{ path: '/course', query: { c: child.name } }"
        >{{ child.name }}</router-link
      >
      <div v-if="classInfo.hasChildren" class="classTypeList">
        <h5>{{ classInfo.title }}</h5>
        <div
          v-for="(child, childIndex) of classInfo.list"
          :key="childIndex"
          class="line"
        >
          <router-link
            :to="{ path: '/course', query: { c: child.name } }"
            class="classTypeBlod"
            >{{ child.name }}</router-link
          >
          <router-link
            v-for="(leaf, leafIndex) of child.children"
            :key="leafIndex"
            class="classTypeLink"
            :to="{ path: '/course', query: { c: leaf.name } }"
            >{{ leaf.name }}</router-link
          >
        </div>
      </div>
    </div>
    <router-link to="/course" class="allTypeBtn">全部课程</router-link>
  </div>
</template>

<script>
import { getIndexClassify } from "../../server/index_classify";

export default {
  data() {
    return {
      classify: [],
    };
  },
  mounted() {
    this.fetchClassify();
  },
  methods: {
    async fetchClassify() {
      let result = await getIndexClassify();
      this.classify = result;
    },
  },
};
</script>

<style scoped>
.classType {
  width: 200px;
  height: 440px;
  display: inline-block;
  padding-top: 23px;
  background-color: white;
  position: relative;
}
h4 {
  color: #151515;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-left: 13px;
}
.classTypeItem {
  z-index: 1;
  padding-bottom: 16px;
  padding-left: 27px;
}
h6 {
  color: #003399;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
}
h6:before {
  content: "";
  position: absolute;
  left: -14px;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #003399;
}
.classTypeLink {
  display: inline-block;
  color: #151515;
  font-size: 14px;
  margin-right: 5px;
  line-height: 25px;
}
.classTypeLink:hover {
  color: var(--link-hover-color);
}
.allTypeBtn {
  display: block;
  width: 160px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 2px;
  color: #003399;
  font-size: 12px;
}
.allTypeBtn:hover {
  background-color: #f0f0ff;
}
.allTypeBtn:before {
  content: "";
  display: inline-block;
  vertical-align: text-bottom;
  width: 14px;
  height: 14px;
  margin-right: 4px;
  background: url(../../assets/icon_menu.png);
  background-size: 100% 100%;
}
.classTypeList {
  display: none;
  position: absolute;
  width: 780px;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 200px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.06);
  background-color: #fff;
  z-index: 2;
  padding: 30px 20px;
}
.classTypeItem:hover .classTypeList {
  display: block;
}
.classTypeItem:hover .classTypeList h5 {
  color: #151515;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
}
.classTypeItem:hover .classTypeList .classTypeBlod {
  display: inline-block;
  color: #151515;
  font-size: 14px;
  font-weight: bold;
  width: 100px;
  margin-bottom: 25px;
}
.classTypeItem:hover .classTypeList .classTypeBlod:hover {
  color: var(--link-hover-color);
}
.classTypeItem:hover .classTypeList .classTypeLink {
  display: inline-block;
  color: #5d5d5d;
  font-size: 13px;
  margin-right: 8px;
}
.classTypeItem:hover .classTypeList .classTypeLink:hover {
  color: var(--link-hover-color);
}
</style>